import { render, staticRenderFns } from "./DeleteOuter.vue?vue&type=template&id=77045344&scoped=true&"
import script from "./DeleteOuter.vue?vue&type=script&lang=js&"
export * from "./DeleteOuter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77045344",
  null
  
)

export default component.exports